import { IGetAllOCProdutoServicosParaEntregaUseCase } from "../../../presentation/useCases/read/get_all_o_c_produto_servicos_para_entrega_use_case";
import { ProdutoServicoParaEntrega } from "../../models/produto_servicos_para_entrega";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * GetAllOCProdutoServicosParaEntregaUseCase
 */

export class GetAllOCProdutoServicosParaEntregaUseCase implements IGetAllOCProdutoServicosParaEntregaUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async getAllOCProdutoServicosParaEntrega(
    idOrdemCompra: number | undefined,
  ): Promise<ProdutoServicoParaEntrega[]> {
    if (idOrdemCompra === undefined) throw new Error('Falha o obter o id da ordem de compra!');
    return await this.repository.getAllOCProdutoServicosParaEntrega(idOrdemCompra);
  }
}
